import React from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

type Props = {
  compareRunId: string | null;
  compareTraceView?: React.ReactNode;
  peekedTraceView?: React.ReactNode;
};

const CompareTraceLayout: React.FC<Props> = ({
  compareRunId,
  compareTraceView,
  peekedTraceView,
}) => {
  if (!compareRunId) {
    return peekedTraceView;
  }
  return (
    <PanelGroup direction="horizontal" className="-mx-4 flex-1">
      <Panel
        minSize={30}
        className="flex min-w-[300px] flex-col"
        id="peeked-trace-view"
      >
        {peekedTraceView}
      </Panel>
      <PanelResizeHandle className="group relative flex items-stretch text-primary data-[resize-handle-active]:text-brand-primary">
        <div className="w-[2px] bg-brand-tertiary" />
        <div className="absolute inset-y-0 -left-[4px] z-10 w-[9px] opacity-0" />
        <div className="absolute inset-y-0 w-[2px] bg-brand-tertiary opacity-0 transition-all group-hover:opacity-100" />
      </PanelResizeHandle>
      <Panel
        minSize={30}
        className="flex min-w-[300px] flex-col"
        id="compare-trace-view"
      >
        {compareTraceView}
      </Panel>
    </PanelGroup>
  );
};

export { CompareTraceLayout };
